<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-sm-10 col-md-6 col-lg-9">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else><i class="far fa-truck m-r-sm"></i> Job {{ job.number }}</h1>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3" v-if="notLoading">
          <p class="job-status-header" :class="`text-${job.status_class}`">{{ job.status_text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: {
      ...mapGetters('job', {'job': 'jobDecorated'})
    }
  }
</script>



// WEBPACK FOOTER //
// ShowHeading.vue?4f9702e0